"use client";

import NarrativeSidebar from "../../components/sidebars/NarrativeSidebar";
import { NarrativeOutput } from "../../components/narratives/NarrativeOutput";
import useAdsPageStore from "../../store/adsPageStore";
import { useEffect } from "react";
import { getVideoByOwnerId } from "../../services/ads/videos/videosService";
import { useVideo } from "../../context/VideoContext";


export default function HyphensPage() {
  const { selectedNarrative } = useAdsPageStore();
  const { setVideos } = useVideo();


  const getListVideosService = async () => {
    await getVideoByOwnerId()
      .then((response) => {
        setVideos(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    getListVideosService();
  }, []);


  return (
    <div className="flex min-h-screen bg-[#F5F6FA] h-screen overflow-hidden scrollbar-hide font-['Plus_Jakarta_Sans']">
      <NarrativeSidebar />

      <div className="flex-1 overflow-y-auto">

        {selectedNarrative && (
          <NarrativeOutput
            getListVideosService={getListVideosService}
            productId={selectedNarrative.product_information?.id || ""}
            narrativeId={selectedNarrative.id || ""}
            narrative={selectedNarrative.content_narrative}
            style={selectedNarrative.style || ""}
            title={selectedNarrative.narrative_name}
            videoType={selectedNarrative.video_type}
          />
        )}
      </div>
    </div>

  );
}
